import React from 'react';
import PropTypes from 'prop-types';
import { Button, Box } from '@mui/material';
import { trakrefBlue } from '../../color_utils';

const DropdownButton = ({
    leftContent,
    rightContent,
    onClick,
    fullWidth,
    disabled,
    leftFlexGrow,
    rightWidth,
    sx
}) => {
    return (
        <Button
            onClick={onClick}
            disabled={disabled}
            variant="outlined"
            disableRipple
            disableElevation
            sx={{
                width: fullWidth ? '100%' : 'auto',
                height: '36px',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'stretch',
                color: trakrefBlue,
                border: `1px solid ${trakrefBlue}`,
                borderRadius: '4px',
                padding: 0,
                minWidth: 0,
                textTransform: 'none',
                boxShadow: 'none',
                ...sx
            }}
        >
            {/* Left side - Main icon/content area */}
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flex: leftFlexGrow ? 1 : 'none',
                    padding: '6px 12px'
                }}
            >
                {leftContent}
            </Box>

            {/* Visual divider */}
            <Box
                sx={{
                    width: '1px',
                    backgroundColor: trakrefBlue,
                    alignSelf: 'stretch',
                    flexShrink: 0
                }}
            />

            {/* Right side - Dropdown indicator area */}
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    minWidth: rightWidth,
                    width: rightWidth,
                    padding: '6px'
                }}
            >
                {rightContent}
            </Box>
        </Button>
    );
};

DropdownButton.propTypes = {
    leftContent: PropTypes.node.isRequired,
    rightContent: PropTypes.node.isRequired,
    onClick: PropTypes.func,
    fullWidth: PropTypes.bool,
    disabled: PropTypes.bool,
    leftFlexGrow: PropTypes.bool,
    rightWidth: PropTypes.string,
    sx: PropTypes.object
};

DropdownButton.defaultProps = {
    onClick: () => {},
    fullWidth: false,
    disabled: false,
    leftFlexGrow: true,
    rightWidth: '48px',
    sx: {}
};

export default DropdownButton;
